import 'css-chunksrc/client/pages/planzoneParametersPage/styles.scss';export default {
  "planzoneParametersPage": "_planzoneParametersPage_69jsm_1",
  "header": "_header_69jsm_8",
  "title": "_title_69jsm_17",
  "profileNavigation": "_profileNavigation_69jsm_21",
  "main": "_main_69jsm_29",
  "group": "_group_69jsm_38",
  "section": "_section_69jsm_42",
  "subLink": "_subLink_69jsm_54",
  "subMenuItems": "_subMenuItems_69jsm_67",
  "apiSection": "_apiSection_69jsm_81",
  "apiLink": "_apiLink_69jsm_87"
};